__turbopack_context__.v({
  "overviewContainer": "GuidanceOverview-module-scss-module__hoT-jW__overviewContainer",
});
